import { COLORS } from '../../constants';

const styles = () => ({
  dismissButton: {
    color: COLORS.WHITE,
  },
});

export default styles;
